// extracted by mini-css-extract-plugin
export default {"searchContainer":"searchResultsPage_searchContainer__L+m1Q","searchHeading":"searchResultsPage_searchHeading__PWAwz","searchQuery":"searchResultsPage_searchQuery__yk2o5"};